import React, { useEffect, useContext, useState } from 'react'
import { ConferenceContext } from '../../contexts/conference'
import formbricks from '@formbricks/js'

export function FormbricksProvider ({
    children
}: {
    children: React.ReactNode
}): JSX.Element {
    const conference = useContext(ConferenceContext)
    const [isInitialized, setIsInitialized] = useState(false)

    // Initialize Formbricks on mount if enabled
    useEffect(() => {
        const shouldInitialize = process.env.REACT_APP_FORMBRICKS_ENABLED === 'true' && typeof window !== 'undefined'

        if (!shouldInitialize || isInitialized) return

        // Initialize Formbricks with basic configuration first
        void formbricks
            .init({
                environmentId: process.env.REACT_APP_FORMBRICKS_ENV_ID || '',
                apiHost: process.env.REACT_APP_FORMBRICKS_URL || '',
                attributes: {
                    language: navigator.language?.slice(0, 2) || 'en'
                }
            })
            .then(() => {
                setIsInitialized(true)
            })
            .catch((error: unknown) => {
                console.warn('Failed to initialize Formbricks:', error)
            })
    }, [isInitialized])

    // Update user details when conference session starts
    useEffect(() => {
        if (!isInitialized) return

        if (conference.status === 'session-joined' && 'classroomStateOnJoin' in conference) {
            const classroomState = conference.classroomStateOnJoin
            const currentUserId = sessionStorage.getItem('userId')

            if (!currentUserId || !classroomState) return

            let currentUser = null
            if (currentUserId === classroomState.teacher.id) {
                currentUser = classroomState.teacher
            } else {
                currentUser = classroomState.dcAppData.students.find((student: any) => student.id === currentUserId)
            }

            if (!currentUser) return

            const attributes: Record<string, string | number> = {
                role: currentUser.role,
                firstName: currentUser.firstName,
                lastName: currentUser.lastName,
                classroomId: classroomState.id,
                classroomCode: classroomState.code,
                classroomType: classroomState.activityType,
                centerType: classroomState.centerType,
                language: navigator.language?.slice(0, 2) || 'en'
            }

            // Update user details and attributes
            // Set attributes individually
            Object.entries(attributes).forEach(([key, value]) => {
                void formbricks.setAttribute(key, value)
            })
        }
    }, [conference.status, isInitialized])

    return <>{children}</>
}
